import { render, staticRenderFns } from "./Form_16Annexure.vue?vue&type=template&id=37ddf62f&scoped=true"
import script from "./Form_16Annexure.vue?vue&type=script&lang=js"
export * from "./Form_16Annexure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ddf62f",
  null
  
)

export default component.exports